import React, {useEffect,useState} from 'react';
import {useSelector, } from 'react-redux';
import {kycModalSelector} from '../../../../store/selectors';
import {tokenSelector, directLandingSelector, statusSelector,errorSelector,sessionExpireSelector} from '../../../../store/selectors';

import * as C from '../Common.styles';

const FormChild = ({error, modal, showModal}) => {

    const sessionExpiry = useSelector(sessionExpireSelector);

    const [timeLeft, setTimeLeft] = useState(sessionExpiry);
    const [count, setCount] = useState(0);
    const kycModal = useSelector(kycModalSelector);

    useEffect(() => {
        let value = null
        if (error ) {return};
        if (kycModal && !timeLeft) {return}
        if (!timeLeft && modal) {return}
        if (!timeLeft && count==0) {showModal(true);setCount(1)}
        if (timeLeft && !modal) {value=tick()}
        return (()=>{if (value) {clearTimeout(value)}})
    },)

    const tick = () => {
        let timeoutFunction = setTimeout(function(){
            setTimeLeft(timeLeft-1);
        }, 1000);
        return timeoutFunction
    }

    const getTime = (time) => {
        let min = Math.floor(time / 60);
        let seconds = time - (min * 60);
        let secondsDisplay = seconds ? (seconds < 10 ? `0${seconds}s` : `${seconds}s`) : '00s '
        return `${min}m ${secondsDisplay}`
        }

    return <C.SignUpStepCounterWrap><C.SignUpStepCounterWrapInner>Session expires in  :  {getTime(timeLeft)}</C.SignUpStepCounterWrapInner></C.SignUpStepCounterWrap>
}

export default FormChild